/**
 * Checks if any of the given licenses are present in the Firm.
 * @public
 * @param appConfig - Application Configuration object that contains the License information.
 * @param licenses - The licensed to check.
 * @returns `true` if licenses are present, `false` otherwise.
 */
export function hasFirmSomeLicense(appConfig, licenses) {
    const grants = appConfig.Licenses;
    let granted = false;
    if (Array.isArray(licenses)) {
        licenses.some(license => {
            granted = grants.includes(license);
            return granted;
        });
    }
    else if (typeof licenses === 'string') {
        granted = grants.includes(licenses);
    }
    return Boolean(granted);
}
/**
 * Checks if all of the given licenses are present in the Firm.
 * @public
 * @param appConfig - Application Configuration object that contains the License information.
 * @param licenses - The licensed to check.
 * @returns `true` if licenses are present, `false` otherwise.
 */
export function hasFirmEveryLicense(appConfig, licenses) {
    const grants = appConfig.Licenses;
    let granted = false;
    if (Array.isArray(licenses)) {
        licenses.every(license => {
            granted = grants.includes(license);
            return granted;
        });
    }
    else if (typeof licenses === 'string') {
        granted = grants.includes(licenses);
    }
    return Boolean(granted);
}
